import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { Element } from 'react-scroll'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Hero from '../components/hero'
import IntroSection from '../components/sections/intro'
import ParametersSection from '../components/sections/parameters'
import UsageSection from '../components/sections/usage'
// import WhySection from '../components/sections/why'
import CalculatorSection from '../components/sections/calculator'
import ReferencesSection from '../components/sections/references'
import ContactSection from '../components/sections/contact'

const IndexPage = ({ data }) => {
  const { hero } = data
  const [investValue, setInvestValue] = useState(0)

  return (
    <Layout hidingHeader>
      <SEO
        title="Investice do nemovitostních dluhopisů"
        description="Investice do nemovitostí skrze firemní dluhopisy Acrebond."
      />

      <Hero
        image={hero.childImageSharp.gatsbyImageData}
        title="Stabilní investice,<br>které budete rozumět"
        subtitle="7% výnos"
      />

      <Element name="investice-do-nemovitosti">
        <IntroSection />
      </Element>

      <ParametersSection investValue={investValue} />

      <Element name="obchodni-strategie">
        <UsageSection />
      </Element>

      {/* <Element name="proc-investovat">
        <WhySection image={homeBg.childImageSharp.gatsbyImageData} />
      </Element> */}

      <Element name="kalkulacka">
        <CalculatorSection onRangeChange={(value) => setInvestValue(value)} />
      </Element>

      <ReferencesSection />

      <Element name="kontakt" id="kontakt">
        <ContactSection investValue={investValue} />
      </Element>
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    hero: PropTypes.shape({
      childImageSharp: PropTypes.object.isRequired,
    }),
    homeBg: PropTypes.shape({
      childImageSharp: PropTypes.object.isRequired,
    }),
    referenceImages: PropTypes.array,
  }),
}

export default IndexPage

export const pageQuery = graphql`
  query {
    hero: file(relativePath: { eq: "hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED)
      }
    }
  }
`
